import { Box, Card, CardContent } from "@mui/material";
import { useEffect, useState } from "react";
import QuestionForm from "./QuestionForm";

const AddQuestion = ({ onQuestionAdded }) => {
    const [alertMessage, setAlertMessage] = useState({ success: false, message: "" });

    const closeAlert = () => {
        setAlertMessage((alert) => ({ ...alert, message: "" }));
    };

    useEffect(() => {
        let timeout = setTimeout(() => {
            closeAlert();
        }, 5000);
        return () => clearTimeout(timeout);
    }, [alertMessage]);

    return (
        <>
            <Box p={2} py={5} className="bg-white border border-slate-100 rounded-[10px]">
                <div className="font-bold text-[20.7px] px-4 text-slate-600 mb-4 ">Add question</div>

                <Card variant="outlined" className="border-none overflow-visible">
                    <CardContent>
                        <QuestionForm onQuestionAdded={onQuestionAdded} />
                    </CardContent>
                </Card>
            </Box>
        </>
    );
};

export default AddQuestion;
